export const schema = {
  type: "object",
  properties: {
    title: { type: "string" },
    done: { type: "boolean" },
    name: { type: "string" },
    address: { type: "string" },
    surname: { type: "string" },
    schoolname: { type: "string" },
    text2: { type: "string" },
    date: { type: "string" },
  },
};
